import {AbstractList} from "./abstract-list";

export class BurningTaskList extends AbstractList {
  private listParent: HTMLElement;

  constructor(item: HTMLElement) {
    super(item);

    this.listParent = this.item.closest(`.task__wrapper`)!;
  }

  showList() {
    this.listParent.classList.remove(`task__wrapper--hide`);
  }

  hideList() {
    this.listParent.classList.add(`task__wrapper--hide`);
  }

  updateItems() {
    super.updateItems();

    if (this.getItems().length > 0) {
      this.showList();
    } else {
      this.hideList();
    }
  }
}
